export const moreHorizontal = {
  name: "more-horizontal" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M6.75 13.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM10.5 12a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Zm6.75 1.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z" clip-rule="evenodd"/></svg>`,
  keywords: ["more-horizontal"],
  category: "utility" as const,
};
